import React, { Component } from "react";
import { connect } from "react-redux";
import { setAndGetAttributes } from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import {callPOST} from '../../Utils/ApiUtil';
import {fileNameShortenForDisplay, isSet, parameterizedURLAccessToken} from '../../Utils/CommonFunctions';
import {
  validateFilesWithinSizeLimit,
  reportFileSizeValidationError,
  MAX_FILE_UPLOAD_SIZE_MB,
} from '../../Utils/FileUploadValidation';
import { loader } from '../../store/actions/auth';
import { failMessage, succMessage } from '../../store/actions/CommonActions';

class FileUpload extends Component {

  fileObj = [];
  fileArray = [];

  constructor(props) {
    super(props)
    this.state = {
      files: [],
      totalSize: 0,
      isLoading: false,
    }
    this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this)
    this.uploadFiles = this.uploadFiles.bind(this)
  }

  updateFilesSizes = () => {
    // Can be implemented if needed for total size calculation
  }

  uploadFileAPICall = (files) => {
    const { value = [], max, changeHandler, onError, onLoading } = this.props;
    const currentFiles = isSet(value, []);
    let totalFileLength = currentFiles.length + files.length;
    const maxFiles = max || this.props.attributes?.max || 1;
    
    if (totalFileLength > Number(maxFiles)) {
      const errorMsg = 'You can upload a maximum of ' + maxFiles + ' files only';
      if (this.props.failMessage) {
        this.props.failMessage(errorMsg);
      } else if (onError) {
        onError(errorMsg);
      } else {
        console.error(errorMsg);
      }
      return false;
    }

    const sizeValidation = validateFilesWithinSizeLimit(files, { existingFiles: currentFiles });
    if (!sizeValidation.valid) {
      reportFileSizeValidationError(sizeValidation.errorMsg, {
        onError,
        failMessage: this.props.failMessage,
      });
      return false;
    }

    if (onLoading) {
      onLoading(true);
    } else {
      this.setState({ isLoading: true });
    }

    let uploadPromises = [];
    Object.entries(files).forEach(([key, fileItem]) => {
      const formData = new FormData();
      formData.append("upload_file", fileItem);
      const APIURL = 'files/upload';
      const uploadPromise = callPOST(APIURL, formData, {'Content-Type': 'multipart/form-data'})
        .then(res => {
          if (res.status === 200) {
            const response = res.data;
            if (response.code === 200) {
              const responseData = response.data;
              return {
                id: responseData,
                value: responseData,
                // checked: null,
                // file: fileItem,
                label: fileItem.name,
                size: fileItem.size
              };
            } else {
              const errorMsg = (res.message !== '') ? res.message : 'Something went wrong..';
              if (this.props.failMessage) {
                this.props.failMessage(errorMsg);
              } else if (onError) {
                onError(errorMsg);
              } else {
                console.error(errorMsg);
              }
              throw new Error(errorMsg);
            }
          } else {
            const errorMsg = 'Something went wrong..';
            if (this.props.failMessage) {
              this.props.failMessage(errorMsg);
            } else if (onError) {
              onError(errorMsg);
            } else {
              console.error(errorMsg);
            }
            throw new Error(errorMsg);
          }
        })
        .catch(err => {
          console.log(err);
          const errorMsg = 'Something went wrong';
          if (this.props.failMessage) {
            this.props.failMessage(errorMsg);
          } else if (onError) {
            onError(errorMsg);
          } else {
            console.error(errorMsg);
          }
          throw err;
        });
      uploadPromises.push(uploadPromise);
    });

    // Wait for all uploads to complete, then update the files array
    Promise.all(uploadPromises)
      .then(uploadedFiles => {
        // Filter out any failed uploads (they will be undefined)
        const successfulUploads = uploadedFiles.filter(file => file !== undefined);
        if (successfulUploads.length > 0) {
          // Get current value again in case it changed
          const latestFiles = isSet(this.props.value, []);
          const filesArr = [...latestFiles, ...successfulUploads];
          changeHandler(filesArr);
          this.updateFilesSizes();
        }
      })
      .catch(err => {
        console.log('Some uploads failed:', err);
      })
      .finally(() => {
        if (this.props.Loader) {
          this.props.Loader(false);
        } else if (onLoading) {
          onLoading(false);
        } else {
          this.setState({ isLoading: false });
        }
      });
  }

  uploadMultipleFiles(e) {
    let updateFiles = this.state.files;
    this.uploadFileAPICall(e.target.files);
    updateFiles.push(e.target.files)
    this.setState({ files: updateFiles });
    this.updateFilesSizes();
    // Reset file input to allow re-uploading the same file
    if (this.refs.uploadMultipleFiles) {
      this.refs.uploadMultipleFiles.value = '';
    }
  }

  uploadFiles(e) {
    e.preventDefault()
  }

  onFileChange = () => {
    const { disabled, readOnly } = this.props;
    if (disabled === true || readOnly === true) {
      return false;
    }
    
    const { value = [], max, onError } = this.props;
    const currentFiles = isSet(value, []);
    const maxFiles = max || this.props.attributes?.max || 1;
    
    if (currentFiles.length >= Number(maxFiles)) {
      const errorMsg = 'Maximum ' + maxFiles + ' files allowed';
      if (this.props.failMessage) {
        this.props.failMessage(errorMsg);
      } else if (onError) {
        onError(errorMsg);
      } else {
        console.error(errorMsg);
      }
      return false;
    }
    
    var inputField = this.refs.uploadMultipleFiles;
    if (inputField) {
      inputField.click();
    }
  }

  changeHandlerFile = (event) => {
    // Can be used for additional file change handling if needed
  }

  removeAddedFile = (Fileindex) => {
    const { value = [], changeHandler } = this.props;
    let updateFiles = [...value];
    updateFiles = updateFiles.filter((item, index) => {
      if (index !== Fileindex) {
        return item;
      }
    })
    changeHandler(updateFiles);
    this.updateFilesSizes();
  }

  callDownloadImgFile = (itemFile) => {
    document.location.href = parameterizedURLAccessToken('files/download?fileId=' + itemFile.id);
  }

  render() {
    const {
      value = [],
      max,
      className,
      disabled,
      readOnly,
    } = this.props;

    let attr = setAndGetAttributes(this.props);
    const filesLength = isSet(value, []).length;
    const maxFiles = max || this.props.attributes?.max || 1;
    const isMultiple = Number(maxFiles) > 1;

    return (
      <Wrp>
        <div className="border" style={{ borderRadius: '0.25rem', padding: '5px', width: '100%' }}>
          <div className="position-relative">
            <input
              type="file"
              ref="uploadMultipleFiles"
              multiple={isMultiple ? 'multiple' : ''}
              style={{ display: 'none' }}
              onChange={this.uploadMultipleFiles}
              disabled={disabled || readOnly}
            />

            <div
              className="border-bottom card-title mb-2 cursor-pointer"
              onClick={this.onFileChange}
              style={{ cursor: (disabled || readOnly) ? 'not-allowed' : 'pointer', opacity: (disabled || readOnly) ? 0.6 : 1 }}
            >
              <div className="totalFileSize text-left">
                Maximum <b>{MAX_FILE_UPLOAD_SIZE_MB} MB</b> per file and <b>{MAX_FILE_UPLOAD_SIZE_MB} MB</b> total per upload. Up to <b className="proximas">{maxFiles}</b>&nbsp;
                files allowed
              </div>
              <div className="text-right">
                <i className="fas fa-upload secondary_color"></i> <small>Upload New</small>
              </div>
            </div>
          </div>

          {(filesLength > 0) ?
            <div className="row">
              <div className="col-12">
                {
                  value.map((itemFile, index) => {
                    const ext = itemFile.label.split('.').pop();
                    let fileIcon = 'fas fa-file';
                    let roundedClass = '';
                    if (ext === 'pdf') {
                      fileIcon = 'fas fa-file-pdf';
                      roundedClass = 'bg-danger';
                    } else if (ext === 'doc' || ext === 'docx') {
                      fileIcon = 'far fa-file-word';
                      roundedClass = 'bg-info';
                    } else if (ext === 'xls' || ext === 'xlsx') {
                      fileIcon = 'far fa-file-excel';
                      roundedClass = ' bg-success';
                    } else if ((itemFile.label).match(/.(jpg|jpeg|png|gif)$/i)) {
                      fileIcon = 'fas fa-upload';
                      roundedClass = ' bg-success';
                    }
                    const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
                    return (
                      <div key={index}>
                        <div className="d-flex">
                          <div className="avatar avatar-sm">
                            <span className={"avatar-title rounded-circle border border-white " + roundedClass}>
                              <i className={fileIcon}></i>
                            </span>
                          </div>
                          <div className="flex-1 ml-3 pt-1">
                            <h6 className="fw-bold mb-1">{itemFileLabel}</h6>
                          </div>
                          <div className="float-right pt-1">
                            <small className="text-muted" onClick={() => this.callDownloadImgFile(itemFile)}>
                              <i className="fas fa-download fa-lg cursor-pointer"></i>
                            </small>&nbsp;&nbsp;
                            <small className="text-muted" onClick={() => this.removeAddedFile(index)}>
                              <i className="far fa-trash-alt fa-lg cursor-pointer"></i>
                            </small>
                          </div>
                        </div>
                        <div className="separator-dashed m-1"></div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            :
            <div className="text-center">
              <i className="fas fa-file-image fa-2x last_light_color"></i>
              <p className="last_light_color mb-0 text-small"> No Files added</p>
            </div>
          }
        </div>
      </Wrp>
    );
  }
}

FileUpload.defaultProps = {
  isMandatory: false,
  className: "form-control",
  value: [],
  max: 1,
}

const mapDispatchToProps = dispatch => {
  return {
    Loader: (boll) => dispatch(loader(boll)),
    succMessage: (msg) => dispatch(succMessage(msg)),
    failMessage: (msg) => dispatch(failMessage(msg)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(FileUpload);

